export default {
  fr: {
    damages: {
      scratch: "rayure",
      bumps: "chocs",
      stain: "tache"
    },
    location: {
      label: {
        front: "Avant du véhicule",
        back: "Arrière du véhicule",
        right: "Côté droit",
        left: "Côté gauche",
        inside: "Intérieur"
      },
      pictures: {
        front: "Photos de l'avant du véhicule",
        back: "Photos de l'arrière du véhicule",
        right: "Photos du côté droit",
        left: "Photos du côté gauche",
        inside: "Photos de l'intérieur"
      }
    }
  }
}
